import PropTypes from 'prop-types'
import React, { Component } from 'react'
import RadioOption from 'components/shared/RadioOption'
import { areWeOpenForBusiness } from 'utils/OpenHoursHelper'
import { WidgetMode, WidgetStatus } from 'constants/EmbedConfigurationConstants'
import { patchOperations } from 'utils/PatchHelper'
import Toggle from '../Toggle'
import cx from 'classnames'

import style from './style.styl'

class WidgetModeSelector extends Component {
  static contextTypes = {
    app: PropTypes.object
  }

  constructor(props) {
    super(props)

    this.onManualModeSelected = this.onManualModeSelected.bind(this)
    this.onAutomaticModeSelected = this.onAutomaticModeSelected.bind(this)

    this.state = {
      widgetStatus: this.props.embed.widgetStatus,
      widgetMode: this.props.embed.widgetMode
    }
  }

  componentWillReceiveProps(nextProps) {

    if (_.isEqual(nextProps.embed, this.props.embed)) return

    this.setState({
      widgetStatus: nextProps.embed.widgetStatus,
      widgetMode: nextProps.embed.widgetMode
    })
  }

  checkIsOpenForBusiness() {
    const {theme: { timezone, openHours }} = this.props.embed
    return (openHours && openHours.length == 0) || areWeOpenForBusiness(timezone, openHours)
  }

  checkIsOnline() {
    const { embed } = this.props
    const { widgetMode, widgetStatus } = embed

    if (widgetMode === WidgetMode.AUTO) {
      return this.checkIsOpenForBusiness()
    } else if (widgetMode === WidgetMode.MANUAL) {
      return widgetStatus === WidgetStatus.ON
    } else {
      return widgetStatus === WidgetStatus.ON && this.checkIsOpenForBusiness()
    }
  }

  onManualModeSelected() {
    const newWidgetStatus = this.checkIsOnline()
      ? WidgetStatus.ON
      : WidgetStatus.AWAY

    this.updateWidgetState(newWidgetStatus, WidgetMode.MANUAL)
  }

  onAutomaticModeSelected() {
    this.updateWidgetState(WidgetStatus.ON, WidgetMode.AUTO)
  }

  updateWidgetState(newWidgetStatus, newWidgetMode) {
    const { widgetState, widgetStatus } = this.state

    const previousState = {
      widgetState,
      widgetStatus
    }
    const updatedState = {
      widgetStatus: newWidgetStatus,
      widgetMode: newWidgetMode
    }
    const changes = patchOperations(updatedState, previousState)

    this.setState({
      widgetStatus: newWidgetStatus,
      widgetMode: newWidgetMode
    })

    this.props.updateEmbed(changes)
  }

  render() {
    const { widgetStatus, widgetMode } = this.state
    const isInAutoMode = widgetMode === WidgetMode.AUTO

    return (
      <div className={style.WidgetModeSelector}>
        <RadioOption selected={!isInAutoMode} onClick={this.onManualModeSelected}>
          <span className="optionTitle">
            Manual
          </span>
          {!isInAutoMode &&
            <Toggle widgetMode={widgetMode} widgetStatus={widgetStatus} updateStatus={this.props.updateEmbed} />
          }
        </RadioOption>
        <RadioOption
          className={cx({ selectorClearance: isInAutoMode })}
          selected={isInAutoMode}
          onClick={this.onAutomaticModeSelected}>
          <span className="optionTitle">
            Automatic
          </span>
          <span className="optionDescription">
            Drift will automatically go online based on your team’s schedule and availability.
          </span>
        </RadioOption>
      </div>
    )
  }
}

export default WidgetModeSelector



// WEBPACK FOOTER //
// ./src/scripts/components/settings/ChatWidget/components/HoursAndTargeting/WidgetModeSelector/index.js